import { useFormContext, Controller } from 'react-hook-form';
import { CloseCircle } from 'iconsax-react';
import { Skeleton } from 'antd';
import { useGetOperatorAttributesQuery } from '../../../../store/services/lookups';

interface VariantsSelectorProps {
  name: string;
  label?: string;
}

export default function VariantsSelector({ name, label }: VariantsSelectorProps) {
  const { control, formState: { errors } } = useFormContext();
  const { data: attributes, isLoading, isFetching } = useGetOperatorAttributesQuery();
  const options = attributes || [];

  const errorMessage = errors[name]?.message as string;

  return (
    <div className="flex flex-col gap-2 mt-4">
      {label && <label className="text-sm font-bold text-gray-800">{label}</label>}
      {isLoading || isFetching ? (
        <div className="flex flex-wrap gap-3 mt-2">
          <Skeleton.Button active size="default" style={{ width: 100 }} />
          <Skeleton.Button active size="default" style={{ width: 120 }} />
          <Skeleton.Button active size="default" style={{ width: 90 }} />
        </div>
      ) : (
        <Controller
          name={name}
          control={control}
          render={({ field }) => {
            const selectedVariants: string[] = field.value || [];

            const toggleVariant = (variant: string) => {
              if (selectedVariants.includes(variant)) {
                field.onChange(selectedVariants.filter((v) => v !== variant));
              } else {
                field.onChange([...selectedVariants, variant]);
              }
            };

            return (
              <div className="flex flex-wrap gap-3 mt-2">
                {options.map((attribute) => {
                  const isSelected = selectedVariants.includes(attribute.id);
                  return (
                    <button
                      key={attribute.id}
                      type="button"
                      onClick={() => toggleVariant(attribute.id)}
                      className={`flex items-center gap-2 px-4 py-2 rounded-lg border transition-colors ${
                        isSelected
                          ? 'bg-[#4DA167] text-white border-[#4DA167]'
                          : 'bg-white text-gray-600 border-gray-200 hover:border-[#4DA167]'
                      }`}
                    >
                      <span>{attribute.name}</span>
                      {isSelected && <CloseCircle size={16} color="#FFFFFF" variant="Linear" />}
                    </button>
                  );
                })}
              </div>
            );
          }}
        />
      )}
      {errorMessage && <span className="text-red-500 text-xs mt-1">{errorMessage}</span>}
    </div>
  );
}
